import React from "react";
import {connect} from "dva";
import {component_tool, framework_tool, utils_tool} from "@/tool";
import ListSelect from "./listSelect";
import {modelUtils} from "../../../../../utils";

const {WizContainer, WizReduxTemplate} = framework_tool;
const {
  WizCard,
  WizRow,
  WizCol,
  WizTypography,
  WizDataTable,
  WizTabs,
  WizIcon
} = component_tool;
let {$$, checkStrLength} = utils_tool;

class GroupUserSelect extends WizContainer {
  componentName = "GroupUserSelect";

  constructor(props) {
    super(props);
    this.state = {
      selectedRows: []
    };
  }

  static defaultProps = {
    _ok: this._ok
  };

  /**
   * modal框的确定按钮触发
   * 可以在里面增加关闭modal前的操作及校验
   */
  _ok = (data) => {
    const {groupId} = data;
    let listDate = this.state.selectedRows;
    const personIdList = [];
    if (!listDate || ($$.isArray(listDate) && !(listDate).length)) {
      wizNotice.warn("请先选择用户");
    } else {
      listDate.forEach(recordData => {
        personIdList.push(
          recordData.personId
        )
      });
      this.doAction({
        path: "groupUserManagement/addGroupUser",
        payload: {
          key: "groupUserAddKey@" + this.props.groupId,
          apiParams: {
            "groupId": groupId,
            "personIdList": personIdList
          }
        }
      });
    }
  };

  updateRows = rows => {
    this.setState({
      rowData: new Date().getTime(),
      selectedRows: rows
    });
  };

  handleClear(id) {
    const {selectedRows} = this.state;
    id
      ? this.setState({
        selectedRows: selectedRows.filter(item => item.id !== id)
      })
      : this.setState({
        selectedRows: []
      });
  }

  propsAndStateOnChange = {
    groupUserAddResult: this._setGroupUserAddState.bind(this)
  };

  _setGroupUserAddState(nextProps, nextState) {
    if (nextProps.groupUserAddResult.code === 1) {
      wizNotice.success("操作成功");
      this.props.changeModal(false, true);
    } else {
      wizNotice.error(nextProps.groupUserAddResult.msg);
    }

  }

  _render() {
    return (
      <WizCard>
        <ListSelect
          selectedRows={this.state.selectedRows}
          updateRows={rows => this.updateRows(rows)}
          handleClear={id => this.handleClear(id)}
          groupId={this.props.groupId}
        />
      </WizCard>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {groupUserManagement} = state;
  const groupUserAddResult = modelUtils.getModelEntity(groupUserManagement, "groupUserAddKey@" + ownProps.groupId);
  return {
    groupUserAddResult: groupUserAddResult
  };
};

const options = {withRef: true};

export default connect(mapStateToProps, null, null, options)(GroupUserSelect);
